import { makeStyles } from '@material-ui/core/styles';
 
export const useStyles = makeStyles((theme) => ({
  container: {
    height: '100vh',
    width: '100%',
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    boxSizing: 'border-box',
  },
  gridItem: {
    width: '100%',
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
  },
  dataGridWrapper: {
    flex: 1,
    minHeight: 0,
    backgroundColor: 'var(--white)',
    borderRadius: theme.spacing(1),
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    '& ::-webkit-scrollbar': {
      display: 'none',
    },
    '& *': {
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
    },
  },
  headerStyle: {
    backgroundColor: '#f5f5f5',
    fontWeight: 600,
    height: '48px',
  },
  containerStyle: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
  },
  addRoleModal: {
    zIndex: 1500,
  },
}));